<div class="accordion-item">
  <h3 class="accordion-header" id="headingOne">
    <button class="accordion-button" (click)="showAddress = !showAddress" [ngClass]="{'collapsed':!showAddress}"
      type="button" data-bs-toggle="collapse" data-bs-target="#INSAddress1" aria-expanded="true"
      aria-controls="INSAddress1">
      <span>Cap Integration</span>
      <div class="arrow"></div>
    </button>
  </h3>
  <div id="INSAddress1" class="accordion-collapse collapse" aria-labelledby="INSAddress1"
    [ngClass]="{'show':showAddress}">
    <div class="accordion-body">
      <div class="col-12">
        <div class="form-check d-flex mb-3" [formGroup]="rootFormGroup.form">
            <input class="form-check-input" type="checkbox" formControlName="isCapShow"
                id="Inscap" (click)="check()"
                name="deliveryItems">
            <label class="form-check-label link" for="Inscap">Enable Cap Integration</label>
        </div>
    </div>
      <div class="row" [formGroup]="payerCapForm" *ngIf="rootFormGroup.value?.isCapShow">
        <div class="col-3 mb-3">
          <label for="instypeOfApi1" class="form-label">Type of Api<span class="mandatory">*</span></label>
            <app-select-dropdown id="instypeOfApi1" [options]="TypeofAPIArray" label="" 
            [placeholder]="'Select'" formControlName="typeOfApi"
            [ngClass]="{'is-invalid' :submitted && payerCapForm?.controls?.['typeOfApi']?.errors?.['required']}"
            ></app-select-dropdown>
          <span *ngIf="submitted && payerCapForm?.controls?.['typeOfApi']?.errors?.['required']"
            class="invalid-feedback d-block" tabindex="0">This field is required</span>
        </div>
        <div class="col-6 mb-3">
          <label for="insBuilingName1" class="form-label">End Point<span class="mandatory">*</span></label>
          <input autocomplete="disabled" type="text" id="insendpoint1" formControlName="endpoint" placeholder="https://example.com" class="form-control"
            [ngClass]="{'is-invalid' : submitted && payerCapForm?.controls?.['endpoint']?.errors?.['required']}"
            appPreventFirstSpace>

          <span *ngIf="submitted && payerCapForm?.controls?.['endpoint']?.errors?.['required']"
            class="invalid-feedback d-block" tabindex="0">This field is required</span>
        </div>
        <div class="col-3 mb-3">
          <label for="insmethod" class="form-label">Method<span class="mandatory">*</span></label>
            <app-select-dropdown id="insmethodArray" [options]="methodArray" label="" 
            [placeholder]="'Select'" formControlName="method"
            [ngClass]="{'is-invalid' :submitted && payerCapForm?.controls?.['method']?.errors?.['required']}"
            ></app-select-dropdown>

          <span *ngIf="submitted && payerCapForm?.controls?.['method']?.errors?.['required']"
            class="invalid-feedback d-block" tabindex="0">This field is required</span>
        </div>
        <div class="col-3 mb-3">
          <label for="instypeOfAuthorization" class="form-label">Type of authorization</label>
          <app-select-dropdown id="instypeOfAuthorization" [options]="authorizationArray" label="" 
            [placeholder]="'Select'" formControlName="typeOfAuthorization"
            [ngClass]="{'is-invalid' :submitted && payerCapForm?.controls?.['typeOfAuthorization']?.errors?.['required']}"
            ></app-select-dropdown>
        </div>
        <div class="col-3 mb-3">
          <label for="insclientId" class="form-label">Client Id</label>
          <input autocomplete="disabled" type="text" id="insclientId" formControlName="clientId" class="form-control"
            appPreventFirstSpace>
        </div>
        <div class="col-6 mb-3">
          <label for="insclinetSecret" class="form-label">Client Secret</label>
          <input autocomplete="disabled" type="text" id="insclinetSecret" formControlName="clinetSecret"
            class="form-control" appPreventFirstSpace>
        </div>
        <div class="col-6 mb-3">
          <label for="insredirectUri" class="form-label">Redirect Uri</label>
          <input autocomplete="disabled" type="text" id="insredirectUri" placeholder="https://example.com" formControlName="redirectUri"
            class="form-control" appPreventFirstSpace>
        </div>
        <div class="col-6 mb-3">
          <label for="instoken" class="form-label">Token</label>
          <input autocomplete="disabled" type="text" id="instoken" formControlName="token" class="form-control"
            appPreventFirstSpace>
        </div>
        <div class="col-3 mb-3">
          <label for="insValidity" class="form-label">Active From to Expired on<span class="mandatory">*</span></label>
          <app-datepicker_v2 formControlName="activeToEnd" [field]="validity_date_v2" [disabled]="isEdit" [isInValid]="(submitted && payerCapForm?.controls?.['activeToEnd']?.errors?.['required'] ||
          (payerCapForm?.controls?.['activeToEnd']?.errors?.['validityPattern']) || (payerCapForm?.controls?.['activeToEnd']?.errors?.['checkEndDate'])
          || (payerCapForm?.controls?.['activeToEnd']?.errors?.['checkStartDate']))">
          </app-datepicker_v2>
          <span *ngIf="submitted && payerCapForm?.controls?.['activeToEnd']?.errors?.['required']"
            class="invalid-feedback d-block" tabindex="0">This field is required</span>
          <span *ngIf="payerCapForm?.controls?.['activeToEnd']?.errors?.['validityPattern']"
            class="invalid-feedback d-block" tabindex="0">{{validationMsg}}</span>
          <span *ngIf="payerCapForm?.controls?.['activeToEnd']?.errors?.['checkEndDate']"
            class="invalid-feedback d-block" tabindex="0">{{EndDateError}}</span>
          <span *ngIf="payerCapForm?.controls?.['activeToEnd']?.errors?.['checkStartDate']"
            class="invalid-feedback d-block" tabindex="0">{{startDateError}}</span>

        </div>
        <div class="col-12 mb-3">
          <label for="insrequestPayloadSchema" class="form-label">Request Payload Schema<span
              class="mandatory">*</span></label>
          <textarea autocomplete="disabled" type="text" id="insrequestPayloadSchema" formControlName="requestPayloadSchema"
            class="form-control min-height-text-area resize-auto"
            [ngClass]="{'is-invalid' : submitted && payerCapForm?.controls?.['requestPayloadSchema']?.errors?.['required']}"
            appPreventFirstSpace></textarea>
          <span *ngIf="submitted && payerCapForm?.controls?.['requestPayloadSchema']?.errors?.['required']"
            class="invalid-feedback d-block" tabindex="0">This field is required</span>
        </div>
      </div>
      <div class="row" *ngIf="!rootFormGroup.value?.isCapShow">
        <div class="col-3 mb-3">
          <label for="instypeOfApi1" class="form-label">Type of Api<span class="mandatory">*</span></label>
            <app-select-dropdown id="instypeOfApi1" [options]="TypeofAPIArray" label="" 
            [placeholder]="'Select'" [disabled]="true"></app-select-dropdown>
        </div>
        <div class="col-6 mb-3">
          <label for="insBuilingName1" class="form-label">End Point<span class="mandatory">*</span></label>
          <input autocomplete="disabled" type="text" placeholder="https://example.com" id="insendpoint1" class="form-control" [disabled]="true">
        </div>
        <div class="col-3 mb-3">
          <label for="insmethod" class="form-label">Method<span class="mandatory">*</span></label>
            <app-select-dropdown id="insmethodArray" [options]="methodArray" label="" 
            [placeholder]="'Select'" [disabled]="true"></app-select-dropdown>
        </div>
        <div class="col-3 mb-3">
          <label for="instypeOfAuthorization" class="form-label">Type of authorization</label>
          <app-select-dropdown id="instypeOfAuthorization" [options]="authorizationArray" label="" 
            [placeholder]="'Select'" [disabled]="true"></app-select-dropdown>
        </div>
        <div class="col-3 mb-3">
          <label for="insclientId" class="form-label">Client Id</label>
          <input autocomplete="disabled" type="text" id="insclientId" class="form-control" [disabled]="true">
        </div>
        <div class="col-6 mb-3">
          <label for="insclinetSecret" class="form-label">Client Secret</label>
          <input autocomplete="disabled" type="text" id="insclinetSecret" [disabled]="true"class="form-control">
        </div>
        <div class="col-6 mb-3">
          <label for="insredirectUri" class="form-label">Redirect Uri</label>
          <input autocomplete="disabled" type="text" id="insredirectUri" placeholder="https://example.com" [disabled]="true" class="form-control">
        </div>
        <div class="col-6 mb-3">
          <label for="instoken" class="form-label">Token</label>
          <input autocomplete="disabled" type="text" id="instoken" class="form-control" [disabled]="true">
        </div>
        <div class="col-3 mb-3">
          <label for="insValidity" class="form-label">Active From to Expired on<span class="mandatory">*</span></label>
          <app-datepicker_v2  [field]="validity_date_disabled" [disabled]="true" >
          </app-datepicker_v2>

        </div>
        <div class="col-12 mb-3">
          <label for="insrequestPayloadSchema" class="form-label">Request Payload Schema<span
              class="mandatory">*</span></label>
          <textarea autocomplete="disabled" type="text" id="insrequestPayloadSchema" [disabled]="true"
            class="form-control min-height-text-area"></textarea>
        </div>
      </div>
    </div>
  </div>
</div>